import { initializeAnalyticsDeferred } from "@nyntax/analytics/instrumentation-client-deferred";

// PostHog for the funnel events in `src/lib/analytics.ts`. Production only,
// once the page is idle, so first paint and the first video frame never wait
// for it. Without NEXT_PUBLIC_POSTHOG_KEY and _HOST it does nothing.
initializeAnalyticsDeferred();
